module.exports = __webpack_public_path__ + "img/background_black.3e1e484a.jpeg";